import { render, staticRenderFns } from "./IconLocationOutline.vue?vue&type=template&id=5c71b5e3&"
import script from "./IconLocationOutline.vue?vue&type=script&lang=ts&"
export * from "./IconLocationOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports